import { Component, Host, Prop, h } from '@stencil/core';

import { onKeysModificationsFormInit } from '../../../actions/actions.validation.keysModifications';
import EventBus from '../../../services/service.eventBus';

@Component({
  tag: 'vehicle-keys-modifications',
  styleUrl: 'vehicle-keys-modifications.css',
  shadow: true,
})
export class VehicleKeysModifications {
  @Prop() questionsKey = [];
  @Prop() questionsToggleModifications = [];
  @Prop() questionsExhaust = [];
  @Prop() questionsAftermarket = [];
  @Prop() questionsStereo = [];
  @Prop() questionsWheelsTires = [];
  @Prop() questionsSuspension = [];
  @Prop() questionsPerformance = [];

  @Prop() keys = {};
  @Prop() modifications = {};
  @Prop() formErrors: Set<string> = new Set();
  @Prop() hasError: boolean = false;
  @Prop() showFormValidation: boolean = false;

  @Prop() showTwoKeysQuestion: boolean = false;
  @Prop() showModificationsQuestion: boolean = false;
  @Prop() showModificationsQuestionGroup: boolean = false;
  @Prop() showModificationRemovalPrompt: boolean = false;

  @Prop() theme: string;
  @Prop() modalPositionOffsetTop: string = '';

  componentWillLoad() {
    onKeysModificationsFormInit();
  }

  componentDidLoad() {
    EventBus.publish('ComponentHasLoaded', 'vehicle-keys-modifications');
  }

  renderQuestions() {
    if (this.showTwoKeysQuestion) {
      return this.questionsKey.map((q) => (
        <question-proxy
          question={q}
          answers={this.keys}
          showXLText={true}
          isDirty={this.showFormValidation}
          hasError={this.formErrors.has(q.questionId)}
          errorMessage="Answer Required"
          whenChanged={() => {
            //  whenChanged prop is reuired to have a callback function
            return true;
          }}
          data-testId={`${q.dataTestId}Proxy`}
          vehicleKeysModButtonStyle={true}
        />
      ));
    }
  }
  showQuestions() {
    return this.questionsAftermarket.length > 0;
  }
  render() {
    return (
      <Host data-testId="vehicleKeysModifications">
        <div class={`${this.theme}-theme box-content`}>
          <div class="font-open-sans">
            {/* Keys Question */}
            <div data-testId="vehicleKeysModificationsQuestion">{this.renderQuestions()}</div>

            {/* Modifications Questions */}
            {this.showQuestions() && (
              <vehicle-modifications
                questionsExhaust={this.questionsExhaust}
                questionsPerformance={this.questionsPerformance}
                questionsStereo={this.questionsStereo}
                questionsSuspension={this.questionsSuspension}
                questionsWheelsTires={this.questionsWheelsTires}
                questionsToggleModifications={this.questionsToggleModifications}
                answers={this.modifications}
                showModificationsQuestion={this.showModificationsQuestion}
                showModificationsQuestionGroup={this.showModificationsQuestionGroup}
                showModificationRemovalPrompt={this.showModificationRemovalPrompt}
                showFormValidation={this.showFormValidation}
                hasError={this.hasError}
                formErrors={this.formErrors}
                data-testId="vehicleModificationsQuestion"
                dataTestId="vehicleModificationsQuestion"
                modalPositionOffsetTop={this.modalPositionOffsetTop}
              />
            )}
          </div>
        </div>
      </Host>
    );
  }
}
